<template>
  <transition name="fade">
    <div v-if="isLoading" class="global-loading-overlay">
      <div class="global-loading-content">
        <div class="spinner"></div>
        <p class="loading-text">{{ loadingMessage }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'GlobalLoading',
  computed: {
    ...mapGetters({
      isLoading: 'globalLoading/isLoading',
      loadingMessage: 'globalLoading/loadingMessage',
    }),
  },
};
</script>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  backdrop-filter: blur(2px);
}

.global-loading-content {
  background: white;
  padding: var(--space-large);
  border-radius: var(--border-radius-medium);
  text-align: center;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  min-width: 200px;
  max-width: 300px;
}

.spinner {
  border: 4px solid var(--color-border);
  border-top: 4px solid var(--color-woot);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 1s linear infinite;
  margin: 0 auto var(--space-small);
}

.loading-text {
  margin: 0;
  color: var(--color-text);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-medium);
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity var(--transition-duration-normal);
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>